var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from 'react';
import { startRecording, saveRecording } from '../helpers';
const initialState = {
    recordingMinutes: 0,
    recordingSeconds: 0,
    initRecording: false,
    mediaStream: null,
    mediaRecorder: null,
    audio: null,
    oggFile: null,
};
const useRecorder = (maxRecorderMintes = 2, maxRecorderSeconds = 0) => {
    const [recorderState, setRecorderState] = React.useState(initialState);
    React.useEffect(() => {
        let recordingInterval = null;
        if (recorderState.initRecording) {
            recordingInterval = setInterval(() => {
                setRecorderState((prevState) => {
                    if (prevState.recordingMinutes === maxRecorderMintes && prevState.recordingSeconds === maxRecorderSeconds) {
                        typeof recordingInterval === 'number' && clearInterval(recordingInterval);
                        return prevState;
                    }
                    else if (prevState.recordingSeconds >= 0 && prevState.recordingSeconds < 59) {
                        return Object.assign(Object.assign({}, prevState), { recordingSeconds: prevState.recordingSeconds + 1 });
                    }
                    else if (prevState.recordingSeconds === 59) {
                        return Object.assign(Object.assign({}, prevState), { recordingMinutes: prevState.recordingMinutes + 1, recordingSeconds: 0 });
                    }
                    else {
                        return prevState;
                    }
                });
            }, 1000);
        }
        else {
            typeof recordingInterval === 'number' && clearInterval(recordingInterval);
        }
        return () => {
            typeof recordingInterval === 'number' && clearInterval(recordingInterval);
        };
    });
    React.useEffect(() => {
        setRecorderState(prevState => {
            if (prevState.mediaStream) {
                return Object.assign(Object.assign({}, prevState), { mediaRecorder: new MediaRecorder(prevState.mediaStream) });
            }
            else {
                return prevState;
            }
        });
    }, [recorderState.mediaStream]);
    React.useEffect(() => {
        const recorder = recorderState.mediaRecorder;
        let chunks = [];
        if (recorder && recorder.state === 'inactive') {
            recorder.start();
            recorder.ondataavailable = (e) => {
                chunks.push(e.data);
            };
            recorder.onstop = () => __awaiter(void 0, void 0, void 0, function* () {
                var _a;
                const blob = new Blob(chunks, { type: (_a = recorderState.mediaRecorder) === null || _a === void 0 ? void 0 : _a.mimeType });
                chunks = [];
                setRecorderState((prevState) => {
                    if (prevState.mediaRecorder) {
                        return Object.assign(Object.assign({}, initialState), { audio: window.URL.createObjectURL(blob), oggFile: blob });
                    }
                    else {
                        return initialState;
                    }
                });
            });
        }
        return () => {
            if (recorder) {
                recorder.stream.getAudioTracks().forEach((track) => track.stop());
            }
        };
    }, [recorderState.mediaRecorder]);
    return {
        recorderState,
        startRecording: () => startRecording(setRecorderState),
        cancelRecording: () => setRecorderState(initialState),
        saveRecording: () => saveRecording(recorderState.mediaRecorder),
    };
};
export default useRecorder;
